<div
  class="tw-flex tw-justify-between tw-gap-4 tw-border-2 tw-border-highlight-200 tw-rounded-xl tw-p-6"
  [ngClass]="{ 'tw-hidden': !showCallout }"
>
  <span>
    {{ "featureAvailableOnPremiumSubscription" | i18n }}
    Upgrade to a Bundle or start your<a [routerLink]="upgradeNavigation.upgradeRoute()">
      free trial</a
    >
    now.
  </span>
  <icon [name]="'close'" [size]="5" (click)="close()"></icon>
</div>
